module.exports = __webpack_public_path__ + "img/s1.e3959228.png";